import { forwardRef } from 'react';
import { NumericFormat as NumberFormat, type NumberFormatValues, type SourceInfo } from 'react-number-format';
import { twMerge } from 'tailwind-merge';
import InputError from '@/components/UI/Form/Error';
import Label from '@/components/UI/Form/Label';
import type { InputProps } from '@/types/Form';
import styles from './Input.module.css';

const MoneyInput = forwardRef<
  HTMLInputElement,
  Omit<InputProps, 'type'> & {
    onValueChange?: (values: NumberFormatValues, sourceInfo: SourceInfo) => void;
  }
>(({ label, value, id, name, error, required, placeholder, customClassName = '', disabled, onChange, className, onValueChange }, ref) => {
  return (
    <div className={`${customClassName}`}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <NumberFormat
        className={twMerge([
          disabled && styles['form-input-disabled'],
          error && styles['form-input-error'],
          styles['form-input-normal'],
          'focus:outline-hidden',
          className,
        ])}
        getInputRef={ref}
        id={id}
        value={value}
        name={name}
        //   className='block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm placeholder-gray-300 focus:outline-hidden'
        thousandSeparator={true}
        decimalScale={2}
        onValueChange={onValueChange}
        onChange={onChange}
        valueIsNumericString
        prefix={'$ '}
        maxLength={21}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
      />
      {error && <InputError>{error.toString()}</InputError>}
    </div>
  );
});

export default MoneyInput;
